/**
 * Service labels — aggregated export.
 *
 * `ALL_SERVICES` is the flat list (for dropdowns / search).
 * `SERVICES_BY_JURISDICTION` is the per-jurisdiction map (for cascading selects).
 *
 * Add a new jurisdiction by creating `<CODE>.ts` and importing it here.
 */

import { UAE_SERVICES } from './UAE';
import { UK_SERVICES } from './UK';
import { USA_SERVICES } from './USA';
import { KSA_SERVICES } from './KSA';
import { PAK_SERVICES } from './PAK';
import { SINGAPORE_SERVICES } from './Singapore';
import { BVI_SERVICES } from './BVI';
import { CAYMAN_SERVICES } from './Cayman';
import type { ServiceLabel } from './types';

export const ALL_SERVICES: readonly ServiceLabel[] = [
  ...UAE_SERVICES,
  ...UK_SERVICES,
  ...USA_SERVICES,
  ...KSA_SERVICES,
  ...PAK_SERVICES,
  ...SINGAPORE_SERVICES,
  ...BVI_SERVICES,
  ...CAYMAN_SERVICES,
] as const;

export const SERVICES_BY_JURISDICTION: Readonly<Record<string, readonly ServiceLabel[]>> = Object.freeze({
  UAE: UAE_SERVICES,
  UK: UK_SERVICES,
  USA: USA_SERVICES,
  KSA: KSA_SERVICES,
  PAK: PAK_SERVICES,
  Singapore: SINGAPORE_SERVICES,
  BVI: BVI_SERVICES,
  'Cayman Island': CAYMAN_SERVICES,
});

export function servicesForJurisdiction(code: string): readonly ServiceLabel[] {
  return SERVICES_BY_JURISDICTION[code] ?? [];
}

export type { ServiceLabel } from './types';